import React, { useState } from 'react';
import { Package, Edit2, Trash2, Calendar, ArrowLeft, Key, Power, PowerOff, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AdminService } from '../../services/api';
import ResetPasswordModal from '../ResetPasswordModal';

const PharmacyDetails = ({ selectedPharmacy, clinics, onBack, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const userRole = Cookies.get('role');
  const [currentStatus, setCurrentStatus] = useState(selectedPharmacy.vendor_approve_status || 'A');
  const [statusLoading, setStatusLoading] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');

  const isActive = currentStatus === 'A';

  const handleToggleStatus = async () => {
    const nextStatus = isActive ? 'D' : 'A';
    const actionLabel = isActive ? 'deactivate' : 'activate';
    if (!window.confirm(`Are you sure you want to ${actionLabel} this pharmacy?`)) return;

    setStatusLoading(true);
    try {
      const response = await AdminService.setVendorStatus(selectedPharmacy.id, nextStatus);
      if (response && response.status === 1) {
        setCurrentStatus(nextStatus);
        selectedPharmacy.vendor_approve_status = nextStatus;
        setAlertMsg(`Pharmacy ${isActive ? 'deactivated' : 'activated'} successfully!`);
        setTimeout(() => setAlertMsg(''), 4000);
      } else {
        alert(response?.msg || 'Failed to update pharmacy status');
      }
    } catch (err) {
      alert(err.message || 'Error updating status');
    } finally {
      setStatusLoading(false);
    }
  };

  const handlePharmacyClick = (pharmacy) => {
    navigate(`/pharmacy-appointments/${pharmacy.id}`);
  };

  return (
    <div className="detail-view">
      {alertMsg && (
        <div className="mb-4 p-3 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-bold flex items-center gap-2">
          <CheckCircle2 size={16} />
          <span>{alertMsg}</span>
        </div>
      )}
      <div className="detail-header">
        <button className="back-btn" onClick={onBack}>
          ← Back to Pharmacies
        </button>
        <div className="flex items-center gap-3">
          <h2>{selectedPharmacy.vendorName}</h2>
          <span className={`status-pill ${isActive ? 'approved' : 'pending'}`}>
            <span className="dot" />
            {isActive ? 'Approved / Active' : 'Deactivated'}
          </span>
        </div>
        <div className="ml-auto flex flex-wrap gap-2">
          <button
            className="create-btn flex items-center gap-1"
            onClick={() => handlePharmacyClick(selectedPharmacy)}
          >
            <Calendar size={16} /> View Appointments
          </button>
          {userRole === 'SuperAdmin' && (
            <>
              <button
                className={`create-btn flex items-center gap-1 ${
                  isActive ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'
                }`}
                onClick={handleToggleStatus}
                disabled={statusLoading}
              >
                {isActive ? <PowerOff size={16} /> : <Power size={16} />}
                {statusLoading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
              </button>
              <button
                className="create-btn flex items-center gap-1 bg-slate-700 hover:bg-slate-800"
                onClick={() => setIsResetModalOpen(true)}
              >
                <Key size={16} /> Reset Password
              </button>
              <button className="create-btn flex items-center gap-1" onClick={onEdit}>
                <Edit2 size={16} /> Edit
              </button>
              <button className="create-btn flex items-center gap-1 bg-red-500 hover:bg-red-600" onClick={onDelete}>
                <Trash2 size={16} /> Delete
              </button>
            </>
          )}
        </div>
      </div>
      <ResetPasswordModal
        vendor={selectedPharmacy}
        isOpen={isResetModalOpen}
        onClose={() => setIsResetModalOpen(false)}
        onSuccess={() => setAlertMsg('Password reset successfully')}
      />
      <div className="detail-content">
        <div className="info-grid">
          <div className="info-item">
            <span className="info-label">Profile Photo:</span>
            {selectedPharmacy.vendor_profile_path ? (
              <img
                src={selectedPharmacy.vendor_profile_path}
                alt={selectedPharmacy.vendorName || 'Doctor Image'}
                className="w-24 h-24 rounded-full object-cover"
              />
            ) : (
              <span>No Image</span>
            )}
          </div>
          <div className="info-item">
            <span className="info-label">Email:</span>
            <span>{selectedPharmacy.vendorEmail}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Mobile Number:</span>
            <span>{selectedPharmacy.vendorConNumber}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Location:</span>
            <span>{selectedPharmacy.location}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Registration Number:</span>
            <span>{selectedPharmacy.regNumber || selectedPharmacy.reg_no}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Address:</span>
            <span>{selectedPharmacy.address}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Linked Clinics:</span>
            <span>
              {selectedPharmacy.clinic}
            </span>
          </div>
        </div>
        {/* <div className="medications-section">
          <h3>Available Medications ({selectedPharmacy.medications?.length || 0})</h3>
          <div className="medications-grid">
            {selectedPharmacy.medications?.map((medication, index) => (
              <div key={index} className="medication-card">
                <Package size={20} />
                <span>{medication}</span>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PharmacyDetails;